// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
  position: relative;
  background-color: var(--lego-yellow);
  padding: 2rem;
  text-align: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.header-brand {
  margin: 0;
  color: #333;
  font-size: 2.5rem;
  font-weight: bold;
  text-transform: uppercase;
}

.header p {
  margin: 0.5rem 0 0;
  color: #666;
  font-size: 1.2rem;
}

@media (max-width: 768px) {
  .header {
    padding: 1.25rem 3.75rem 1rem;
    padding-top: max(1.25rem, env(safe-area-inset-top));
  }

  .header-brand {
    font-size: 1.65rem;
    line-height: 1.15;
  }

  .header p {
    font-size: 0.95rem;
    line-height: 1.4;
  }
}

@media (max-width: 380px) {
  .header {
    padding-left: 3.25rem;
    padding-right: 3.25rem;
  }

  .header-brand {
    font-size: 1.4rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Header/Header.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,oCAAoC;EACpC,aAAa;EACb,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE;IACE,6BAA6B;IAC7B,mDAAmD;EACrD;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,qBAAqB;IACrB,sBAAsB;EACxB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".header {\n  position: relative;\n  background-color: var(--lego-yellow);\n  padding: 2rem;\n  text-align: center;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.header-brand {\n  margin: 0;\n  color: #333;\n  font-size: 2.5rem;\n  font-weight: bold;\n  text-transform: uppercase;\n}\n\n.header p {\n  margin: 0.5rem 0 0;\n  color: #666;\n  font-size: 1.2rem;\n}\n\n@media (max-width: 768px) {\n  .header {\n    padding: 1.25rem 3.75rem 1rem;\n    padding-top: max(1.25rem, env(safe-area-inset-top));\n  }\n\n  .header-brand {\n    font-size: 1.65rem;\n    line-height: 1.15;\n  }\n\n  .header p {\n    font-size: 0.95rem;\n    line-height: 1.4;\n  }\n}\n\n@media (max-width: 380px) {\n  .header {\n    padding-left: 3.25rem;\n    padding-right: 3.25rem;\n  }\n\n  .header-brand {\n    font-size: 1.4rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
